import { useTranslation } from "react-i18next";
import { useEffectOnce } from "react-use";
import { IntersectionFadeIn } from "@/core/shared/v2/ui/intersection-fade-in";
import { FlowSteps, PageHeader, PhoneVerificationForm } from "../components";
import { useRoutes } from "../hooks/use-routes";
import { useCartStore } from "../store/use-cart-store";
import { useGetConfig } from "../store/use-config";
import { addPatientViewEvent, safeTrackEvent } from "../tracking/events";
import { hasProductUpsellPackages } from "../utils/has-product-upsell-packages";

export const PhoneVerification = () => {
  const { t } = useTranslation();
  const config = useGetConfig();
  const { goToCatalog, goToSelectTime, goToUpsell } = useRoutes();
  const { getStandardProduct } = useCartStore();
  const standardProduct = getStandardProduct();
  const hasUpsell = hasProductUpsellPackages(standardProduct);

  useEffectOnce(() => {
    safeTrackEvent(() => addPatientViewEvent(), "add_patient_view", "phone-verification mount");
  });

  const handleOnBack = () => {
    if (hasUpsell) goToUpsell();
    else if (config.withCalendar) goToSelectTime();
    else goToCatalog();
  };

  return (
    <IntersectionFadeIn className="mx-auto w-full max-w-[1275px] px-4 pt-8 pb-14 md:px-8 md:pb-20 lg:px-12">
      <FlowSteps />
      <PageHeader header={`${t("GROUP_ACTIONS_ORDERING.GENERAL.ADD_PERSONAL_DETAILS")}`} onBack={handleOnBack} />
      <PhoneVerificationForm />
    </IntersectionFadeIn>
  );
};
